<template>
  <div class="social-widgets">
    <aside class="social-dock" :aria-label="$t('text.quickContact')">
      <div
        class="social-dock__bg"
        :style="{
          WebkitMaskImage: `url(${chatBgUrl})`,
          maskImage: `url(${chatBgUrl})`,
        }"
        aria-hidden="true"
      ></div>
      <nav class="social-dock__nav">
        <!-- <a
          class="social-dock__item"
          :href="phoneHref"
          :title="phoneTitle"
        >
          <i class="fa-solid fa-phone-volume"></i>
        </a>

        <a
          class="social-dock__item"
          href="https://zalo.me/2490999282525015829"
          target="_blank"
          rel="noopener noreferrer"
          :title="$t('text.contactZalo')"
        >
          <span class="social-dock__zalo">Zalo</span>
        </a>

        <a
          class="social-dock__item"
          href="https://www.messenger.com/login.php?next=https%3A%2F%2Fwww.messenger.com%2Ft%2FThietbivesinhViglacera"
          target="_blank"
          rel="noopener noreferrer"
          :title="$t('text.messenger')"
        >
          <i class="fa-brands fa-facebook-messenger"></i>
        </a>

        <router-link
          class="social-dock__item"
          to="/sell"
          :title="$t('text.storeLocations')"
        >
          <i class="fa-solid fa-location-dot"></i>
        </router-link>

        <router-link class="social-dock__item" to="/" :title="$t('text.home')">
          <i class="fa-solid fa-house"></i>
        </router-link> -->

         <a-tooltip  placement="left" :title="$t('text.manageWebsite')" color="#102542">
          <router-link v-show="show" class="social-dock__item" :to="DASHBOARD" :title="$t('text.manageWebsite')">
            <i class="fa-solid fa-users-gear"></i>
          </router-link> 
        </a-tooltip>

        <a-tooltip placement="left" :title="$t('text.contactPhone')" color="#102542">
         <a
          class="social-dock__item"
          :href="phoneHref"
          :title="phoneTitle"
        >
          <i class="fa-solid fa-phone-volume"></i>
        </a>
        </a-tooltip>

         <a-tooltip placement="left" :title="$t('text.favoriteProducts')" color="#102542">
          <router-link class="social-dock__item" :to="FAVOURITE" :title="$t('text.favoriteProducts')">
             <i class="fas fa-heart"></i>
          </router-link>
      </a-tooltip>
      <a-tooltip placement="left" :title="$t('text.contact')" color="#102542">
       <router-link class="social-dock__item" :to="CONTACT" :title="$t('text.contact')">
          <i class="far fa-address-card"></i>
        </router-link>
      </a-tooltip>
      <a-tooltip placement="left" :title="$t('text.home')" color="#102542">
      <router-link class="social-dock__item" :to="HOME" :title="$t('text.home')">
          <i class="fa-solid fa-house"></i>
        </router-link> 
        </a-tooltip>
      </nav>
    </aside>

    <!-- <div v-show="show" class="social-circles">
      <a-tooltip placement="left" title="Quản trị website" color="#102542">
        <button
          type="button"
          class="social-circle"
          aria-label="Quản trị website"
          @click="managePage"
        >
          <i class="fa-solid fa-users-gear"></i>
        </button>
      </a-tooltip>

      <a-tooltip placement="left" title="Sản phẩm yêu thích" color="#102542">
        <button
          type="button"
          class="social-circle"
          aria-label="Sản phẩm yêu thích"
          @click="goFavorites"
        >
          <i class="fas fa-heart"></i>
        </button>
      </a-tooltip>
    </div> -->

    <a-back-top :visibility-height="400" class="social-back-top" />
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, computed, watch } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import store from "@/store/index";
import commons from "@/utils/Common";
import { COMPANY_DETAIL_COOKIE } from "@/const/ConstCookies";
import chatBg from "@/assets/images/social/chat_bg.png";
import { CONTACT, DASHBOARD, FAVOURITE, HOME } from '@/const/path'

const { t } = useI18n();
const router = useRouter();
const show = ref(false);
const chatBgUrl = chatBg;

const company = computed(() => {
  try {
    const fromStore = commons.getCokiesCompany?.()
    if (fromStore && Object.keys(fromStore).length) return fromStore
    const cookie = commons.getTenantCookie?.(COMPANY_DETAIL_COOKIE)
    if (cookie) {
      return typeof cookie === 'string' ? JSON.parse(cookie) : cookie
    }
    const legacy = JSON.parse(commons.getTenantLocalStorage?.(COMPANY_DETAIL_COOKIE) || 'null')
    return legacy || {}
  } catch {
    return {};
  }
});

const phoneRaw = computed(() => {
  const p = company.value?.phone || company.value?.hotline || "1900989829";
  return String(p).replace(/\s+/g, "");
});

const phoneHref = computed(() => `tel:${phoneRaw.value}`);
const phoneTitle = computed(
  () =>
    `${t("text.contactHotline")}: ${company.value?.phone || phoneRaw.value}`
);

const managePage = () => {
  router.push({ path: DASHBOARD });
};

const goFavorites = () => {
  router.push({ path: FAVOURITE });
};

const loadData = () => {
  show.value = commons.getToken() != null;
};

onMounted(async () => {
  await loadData();
});

const isLoadLogin = computed(() => store.getters.isLoadLogin);
watch(isLoadLogin, async () => {
  await loadData();
});
</script>

<style scoped>
.social-widgets {
  pointer-events: none;
}

.social-widgets :deep(a),
.social-widgets :deep(button),
.social-widgets :deep(.ant-back-top),
.social-widgets :deep(.ant-float-btn) {
  pointer-events: auto;
}

/* Form từ chat_bg.png, màu brand — cao tự giãn theo số icon */
.social-dock {
  position: fixed;
  right: 0;
  /* top: 50%; */
  bottom: -50px;
  transform: translateY(-50%);
  z-index: 100;
  width: 45px;
  height: auto;
  min-height: 0;
  padding: 22px 0;
  background: transparent;
}

.social-dock__bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background-color: var(--primary-dark, #102542);
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: right center;
  mask-position: right center;
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;
  -webkit-mask-mode: alpha;
  mask-mode: alpha;
}

.social-dock__nav {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
  height: auto;
  min-height: 0;
}

.social-dock__item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  color: #fff;
  text-decoration: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.social-dock__item i {
  font-size: 18px;
  line-height: 1;
  color: #fff;
}

.social-dock__item:hover {
  opacity: 0.8;
  transform: scale(1.06);
}

.social-dock__zalo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 22px;
  border: 1.5px solid #fff;
  border-radius: 5px;
  font-size: 7px;
  font-weight: 700;
  color: #fff;
  line-height: 1;
}

.social-circles {
  position: fixed;
  right: 24px;
  bottom: 100px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.social-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 0;
  border-radius: 50%;
  border: 1.5px solid var(--default-header-color, #b19663);
  background: var(--primary-dark, #102542);
  color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(16, 37, 66, 0.35);
  transition: transform 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
}

.social-circle i {
  font-size: 18px;
  color: #fff;
}

.social-circle:hover {
  transform: translateY(-2px);
  background: #0a1829;
  border-color: var(--primary-gold, #d4af37);
}

.social-back-top {
  position: fixed !important;
  right: 8px !important;
  left: auto !important;
  bottom: 24px !important;
  z-index: 100;
}

.social-back-top :deep(.ant-float-btn),
.social-back-top :deep(.ant-float-btn-body),
.social-back-top :deep(.ant-back-top-content) {
  background-color: var(--primary-dark, #102542) !important;
  border: 1px solid #fff !important;
  color: #fff !important;
  box-shadow: none !important;
}

.social-back-top :deep(.ant-float-btn-icon),
.social-back-top :deep(.anticon) {
  color: #fff !important;
}

@media (max-width: 767px) {
  .social-dock {
    width: 44px;
    padding: 18px 0;
  }

  .social-dock__nav {
    gap: 14px;
  }

  .social-dock__item i {
    font-size: 16px;
  }

  .social-circles {
    right: 16px;
    bottom: 88px;
  }

  .social-circle {
    width: 42px;
    height: 42px;
  }

  .social-back-top {
    right: 6px !important;
    bottom: 16px !important;
  }
}
</style>
